<template>
	<section id="about" class="section">
		<div class="container">
			<header v-reveal class="section__head">
				<p class="section__eyebrow">{{ t('about.eyebrow') }}</p>
				<h2 class="section__title">{{ t('about.title') }}</h2>
			</header>

			<div class="about__grid">
				<div v-reveal class="about__copy">
					<!-- the profile highlights a few words with a marker pen -->
					<p
						v-for="index in ABOUT_PARAGRAPH_COUNT"
						:key="index"
						class="about__paragraph"
						v-html="t(`about.paragraph-${index}`)"
					/>
				</div>

				<aside v-reveal="120" class="about__creed">
					<ul>
						<li
							v-for="index in ABOUT_CREED_COUNT"
							:key="index"
							class="about__creed-line"
							v-html="t(`about.creed-${index}`)"
						/>
					</ul>
				</aside>
			</div>

			<h3 v-reveal class="about__team-title">
				<span class="marker">{{ t('about.team-title') }}</span>
			</h3>

			<figure v-reveal="80" class="about__team">
				<img
					:src="assetUrl('team-collage.webp')"
					:alt="t('about.team-alt')"
					width="1400"
					height="789"
					loading="lazy"
				>
			</figure>
		</div>
	</section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ABOUT_CREED_COUNT, ABOUT_PARAGRAPH_COUNT } from '@/helpers/constants'
import { assetUrl } from '@/helpers/functions'

defineOptions({ name: 'AboutSection' })

const { t } = useI18n()
</script>

<style scoped lang="scss">
.about__grid {
	display: grid;
	grid-template-columns: 1.35fr 0.85fr;
	gap: clamp(28px, 5vw, 64px);
	align-items: start;

	@include below($bp-desktop) {
		grid-template-columns: 1fr;
	}
}

.about__paragraph {
	font-size: clamp(1.02rem, 1.6vw, 1.24rem);
	color: #3a3a3a;

	& + & {
		margin-top: 20px;
	}
}

.about__creed {
	position: relative;
	overflow: hidden;
	padding: clamp(26px, 3vw, 38px);
	background: $color-paper;
	border: 1px solid $color-line;
	border-radius: $radius-lg;
	box-shadow: var(--shadow-sm);

	&::before {
		content: '';
		position: absolute;
		top: 0;
		inset-inline-start: 0;
		width: 100%;
		height: 5px;
		background: linear-gradient(90deg, $color-gold, rgba(255, 208, 31, 0));
	}
}

.about__creed-line {
	font-size: clamp(1.06rem, 1.7vw, 1.3rem);
	font-weight: 600;
	color: $color-ink;

	& + & {
		margin-top: 10px;
	}
}

.about__team-title {
	margin-top: clamp(54px, 7vw, 88px);
	font-size: clamp(1.3rem, 3.2vw, 2.1rem);
	font-weight: 800;
	text-align: center;
}

.about__team {
	margin: clamp(24px, 3vw, 38px) 0 0;

	img {
		width: 100%;
		height: auto;
		border-radius: $radius-lg;
		mask-image: linear-gradient(180deg, #000 78%, transparent 100%);
		-webkit-mask-image: linear-gradient(180deg, #000 78%, transparent 100%);
	}
}
</style>
